function StopwatchIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10 3h4m-2 6v4l2 2m6-2a8 8 0 11-16 0 8 8 0 0116 0z"
      ></path>
    </svg>
  );
}

export default StopwatchIcon;
